import React from 'react';
import './ProjectDetails.css';

function ProjectDetails({
  festivals,
  credits = [],
  cast = [],
  festivalHeading = 'FESTIVALS',
  castHeading = 'KEY CAST',
}) {
  const renderRows = (items) => items.map((item, index) => {
    const name = item.names ? item.names.join(', ') : item.name;
    const displayName = name.replace(/\b[A-Z]+\b/g, (word) => (
      word.charAt(0) + word.slice(1).toLowerCase()
    ));
    return (
      <div
        key={`${item.role || 'name'}-${name}-${index}`}
        className={`project-detail-row${item.role ? '' : ' project-detail-row-names-only'}`}
      >
        {item.role && <div>{item.role}</div>}
        <div>{displayName}</div>
      </div>
    );
  });

  return (
    <section className="project-details">
      {festivals && (
        <>
          <h3 className="project-details-heading">{festivalHeading}</h3>
          <div className="project-festivals">
            {festivals.map((festival, index) => (
              <div key={`${festival.name || festival}-${index}`}>
                {typeof festival === 'string' ? (
                  <>{festival}, <em>Official Selection</em></>
                ) : (
                  <>{festival.name}, <em>{festival.note}</em></>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      {credits.length > 0 && (
        <>
          <h3 className="project-details-heading">CREDITS</h3>
          {renderRows(credits)}
        </>
      )}
      {cast.length > 0 && (
        <>
          <h3 className="project-details-heading">{castHeading}</h3>
          {renderRows(cast)}
        </>
      )}
    </section>
  );
}

export default ProjectDetails;
